<template>
  <div class="branding-container">
    <div class="branding-top-bar"></div>
    <div class="branding-body">
      <div class="branding-middle-section">
      <div class="branding-middle-spacer"></div>
      <BrandingElementsLayout>
        <BrandingGroupLayout v-if="hasBrandingLogo"></BrandingGroupLayout>
        <CcUnderwriterLayout v-if="!hasBrandingLogo && getBrandingLogosFetched"></CcUnderwriterLayout>
      </BrandingElementsLayout>
      </div>
    </div>
    <div class="branding-bottom-bar"></div>
    <Footer class="reg-flow-footer"></Footer>
  </div>
</template>

<script setup>
import Footer from '@/components/common/Footer/FooterConnectfn.vue';
import BrandingElementsLayout from '@/components/common/CorporateBranding/BrandingElementsLayout';
import BrandingGroupLayout from '@/components/common/CorporateBranding/BrandingElementsLayout/BrandingGroupLayout';
import CcUnderwriterLayout from '@/components/common/CorporateBranding/BrandingElementsLayout/CCUnderwriterLayout';
import { useCorporateBranding } from '@/composables';

// Define component name
defineOptions({
  name: 'corporate-branding'
});

// Composables
const { 
  brandingData,
  hasEventBranding,
  hasBrandingLogo,
  getBrandingLogos,
  getBrandingLogosFetched
} = useCorporateBranding();
</script>

<style scoped lang="stylus">
.branding-container {
  height: 100%;
  flex-flow: column;
  display: flex;
  overflow: auto;
  .branding-top-bar {
    @media screen and (max-width: 1480px) {
      min-height: 73px;
    }
    @media screen and (max-width: 1280px) {
      min-height: 23px;
    }
    min-height: 128px;
    background-color: var(--secondary-color);
    margin-right: 64px;
  }
  .branding-middle-section {
    display: flex;
    flex-direction: row;
    background-color: var(--secondary-color);

  }
  .branding-bottom-bar {
    flex: 1 1 auto;
    background-color: var(--secondary-color);
    margin-right: 64px;
  }
  .reg-flow-footer {
    background-color: var(--secondary-color);
    margin-right: 64px;
    width: auto;
    :deep(.footer-label:nth-of-type(2)) {
      display: none;
    }
    :deep(.footer-content) {
      justify-content: right;
      margin-right: 64px;
      padding: 0 !important;
      .connectFn_Logo {
        margin-top: 0px;
      }
      .cursor-pointer {
        text-decoration: none;
      }
    }
  }

}
</style>
